@use "~theme/typographyV2" as typography;

.container {
  border: none;
  border-left: 4px solid var(--blue-01);
  display: flex;
  flex-direction: row;
  width: fit-content;
  border-radius: 4px;
  background-color: var(--canvas-tan);
  color: var(--brand-indigo);

  a {
    color: var(--brand-indigo);
  }
}

.action {
  width: 40px;
  display: flex;
  justify-content: center;
  border-right: 1px solid var(--gray-04-at-30);
  padding: 8px;
}

.icon {
  width: 24px;
  height: 24px;
}

.text {
  font-family: typography.$font-mont;
  margin: 8px 40px 8px 12px;

  p {
    margin-top: 0;
  }

  a {
    white-space: nowrap;
  }
}

.dismissButton {
  position: absolute;
  top: 4px;
  right: 8px;
  border: none;
  cursor: pointer;
  background: transparent;
}

.dismissIcon {
  width: 13px;
  height: 13px;
}
